import {Box, Button, Tooltip, MenuItem, Divider} from "@mui/material";
import {
    ACard,
    ADataGrid,
    ADataGridColumn,
    ADataGridFilter,
    ASectionTitle,
    PagedSearchParams
} from "@atiautomacao/ati-ui-library";
import React, {useCallback, useEffect, useState, useRef} from "react";
import {extractFiltersFromColumns} from "../../../Utils/DataUitils";
import {useNavigate} from "react-router-dom";
import {
    AuthorityReactQuery,
    DeleteUsersReactQuery,
    UsersReactQuery
} from "./UsersReactQuery";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {QueryClient, QueryClientProvider} from "react-query";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {DeleteOutlined, EditOutlined, MoreHorizOutlined} from "@mui/icons-material";
import ConfirmDialog from "../../../Shared/Components/ConfirmDialog";
import { hasPermission } from "../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../Config/Constants";
import { useAppSelector } from "../../../Config/Hooks";
import { useSnackbar } from "notistack";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import {SideBar, Permission, User} from "./components/SideBar";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import {sharedQueryClient as queryClient} from "../../../queryClient";

export const initColumns = [
    {
        name: 'id',
        label: 'ID',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'name',
        label: 'Usuário',
        align: 'left',
        visibility: true,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    // {
    //     name: 'userName',
    //     label: 'Username',
    //     align: 'left',
    //     minWidth: 10,
    //     visibility: true,
    //     breakpoints: {
    //         xs: true,
    //         sm: true,
    //         md: true,
    //         lg: true,
    //         xl: true
    //     },
    // },
    {
        name: 'email',
        label: 'E-mail',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'groupList',
        label: 'Grupo',
        align: 'left',
        minWidth: 10,
        visibility: false,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    }
] as ADataGridColumn[]


export type ActionConfig = {
    actionName: string;
    disabled: boolean;
};

export interface RowUsers {
    id?: number;
    name: string;
    username: string;
    email: string;
    groupList?: string;
    actionsConfig?: Array<ActionConfig>
}


function SelectedMenu({
                                         label,
                                         icon,
                                         danger,
                                     }: {
    label: string;
    icon: React.ReactNode;
    danger?: boolean;
}) {
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
            }}
        >
            <Typography sx={{ fontSize: 13, color: danger ? "error.main" : "text.primary" }}>
                {label}
            </Typography>

            <Box
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: danger ? "error.main" : "text.secondary",
                }}
            >
                {icon}
            </Box>
        </Box>
    );
}


export const UsersSettingsPage = () => {
    const { enqueueSnackbar } = useSnackbar();

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSaveUser = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SAVE_USER
    ]);
    const isAuthorizedToDeleteUser = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DELETE_USER
    ]);

    const isAuthorizedToViewUserAuthorityGroup = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.VIEW_USER_AUTHORITIES_GROUP, AUTHORITIES.USER_AUTHORITY_GROUP_MANAGER
    ]);

    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 100));
    const {data, isSuccess} = UsersReactQuery(pagedSearchParams);
    const {authorities, authoritiesSuccess, executeManual} = AuthorityReactQuery();
    const [totalOfRecords, setTotalOfRecords] = useState(0);
    const [rows, setRows] = useState<Array<RowUsers>>([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedToDelete, setSelectedToDelete] = useState<any>(null);
    const [permissions, setPermissions] = useState<Permission[]>([])
    const [selectedUser, setSelectedUser] = useState<User>({id: -1, name: ''})
    const navigate = useNavigate();
    const mutation = DeleteUsersReactQuery(pagedSearchParams);
    const [open, setOpen] = useState(false)

    const [menuPos, setMenuPos] = useState<{ top: number; left: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const lastMousePosRef = useRef<{ x: number; y: number }>({ x: 0, y: 0 });

    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        let newPageParams: PagedSearchParams = new PagedSearchParams(dataGridFilters, page, pageSize);
        setPagedSearchParams(
            newPageParams
        );
    }, []);

    useEffect(() => {
        if(authoritiesSuccess && authorities){
            const newPermissions = authorities.map((item:any) => (
                 {
                    id: item.id,
                    name: item.name,
                    checked: false

                }
            ))
            setPermissions(newPermissions)
        }
    }, [authorities]);

    useEffect(() => {
        if (isSuccess) {
            setTotalOfRecords(data?.totalOfRecords);
            if (data?.data) {
                let rowsAux: Array<RowUsers> = data.data.map((row: any) => {
                    return {
                        id: row.id,
                        name: row.name,
                        userName: row.userName,
                        email: row.email,
                        groupList: row.groupList,
                        actionsConfig: [
                            {actionName: "Editar", disabled: !isAuthorizedToSaveUser},
                            {actionName: "Excluir", disabled: !isAuthorizedToDeleteUser}
                        ]
                    }
                });
                setRows(rowsAux);
            }
        }
    }, [data?.data]);

    const handleEditUsers = useCallback((data: any) => {
        if(isAuthorizedToSaveUser) {
            navigate(SystemRoutes.SETTINGS_USERS_FORM, {state: {id: data.id}});
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa página", {
                variant: 'warning',
            });
            return null;
        }
    }, [navigate]);

    const handleDeleteUsers = useCallback((data: any) => {
        if(isAuthorizedToDeleteUser) {
            setSelectedToDelete(data.id);
            setOpenDialog(true);
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa página", {
                variant: 'warning',
            });
            return null;
        }
        
    }, []);

    const handleDialogConfirm = async () => {
        mutation.mutate({id: selectedToDelete, pagedSearchParams});
        setSelectedToDelete(null);
        handleDialogToggle();
    }

    useEffect(() => {
        if (mutation.isSuccess) {
            setPagedSearchParams(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 50))
        }

    }, [mutation.isSuccess]);

    const handleDialogToggle = () => {
        setOpenDialog(!openDialog);
    }

    const handleDialogClose = () => {
        handleDialogToggle();
    }

    const handleOnClosed = () => {
        executeManual();
        setOpen(false)
    }

    const onSetSelectedPermissions = (list: Permission[]) => {
        if(list && list.length > 0){
            setPermissions(list);
        }
    }

    function handleActionsUnavailability(value: any) {
        setSelectedRow(value);
        setSelectedUser({id: value.id, name: value.name})

        const { x, y } = lastMousePosRef.current;
        setMenuPos({ left: x, top: y });
    }

    function handleCloseActionsMenu() {
        setMenuPos(null);
        setSelectedRow(null);
    }

    function handleMouseMoveInGrid(e: React.MouseEvent<HTMLDivElement>) {
        lastMousePosRef.current = { x: e.clientX, y: e.clientY };
    }

    const handleEditUnavailability = useCallback((data: any) => {
        navigate(SystemRoutes.SETTINGS_USERS_FORM, {state: {id: data.id}});
    }, [navigate]);

    return (
        <Box sx={{marginRight: 5, marginLeft: 3, }}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 2 }}
            >
                <ASectionTitle
                    styleContainer={{ padding: '0' }}
                    styleSubtitle={{marginBottom: 0, paddingTop: 0}}
                    styleContainerTitle={{paddingBottom: 0}}
                    contentChildrenStyle={{marginBottom: 0, marginTop: -2}}
                    titleLabel={'Usuários'}
                    subTitleLabel={'Verifique usuários cadastrados no sistema e seus perfis de acesso'}
                    contentChildren={
                        <Button
                            onClick={() => navigate(SystemRoutes.SETTINGS_USERS_FORM)}
                            variant="contained"
                            startIcon={<AddCircleOutlineIcon />}
                            sx={{
                                paddingTop: 1,
                                paddingBottom: 1,
                                marginBottom: 1,
                                backgroundColor: '#3b66f5',
                                color: 'white',
                                borderRadius: '8px',
                                boxShadow: '0px 2px 4px rgba(0,0,0,0.15)',
                                textTransform: 'uppercase',
                                fontWeight: 500,
                                fontSize: '0.8rem',
                                letterSpacing: '0.02857em',
                                whiteSpace: 'nowrap',
                                height: 'fit-content'
                            }}
                        >
                            Novo Usuário
                        </Button>
                    }
                />
            </Box>
            <ACard
                styleProps={{
                headerStyle: {marginBottom: -6},
                contentStyle: {marginBottom: 0, padding: 0},
                cardStyle: {
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomLeftRadius: '12px',
                    borderBottomRightRadius: '12px',
                    margin: 0,
                    border: 'none',
                    borderBottom: '1px solid #c3c3c3'
                }
            }}>
                <Box
                    onMouseMove={handleMouseMoveInGrid}
                    role="grid"
                    aria-label="Ações de usuários"
                >
                    <ADataGrid
                        size={"small"}
                        hideFilters={false}
                        tableContainerStyle={{borderRadius: 0, paddingLeft: 0, width: '100%'}}
                        ariaLabel={"settings-grid-users"}
                        columns={initColumns}
                        rows={rows}
                        page={pagedSearchParams.page}
                        rowsPerPage={pagedSearchParams.size}
                        loading={false}
                        totalOfRecords={totalOfRecords}
                        hideSelection={true}
                        onFiltersChange={handleOnFiltersChange}
                        actions={
                            <>
                                <span></span>
                                <IconButton name="edit"
                                            size={"small"}
                                            aria-label="Edit"
                                            onClick={(value) => handleActionsUnavailability(value)}
                                >
                                    <Tooltip title="Opções">
                                        <MoreHorizOutlined/>
                                    </Tooltip>
                                </IconButton>
                            </>
                        }
                    />
                    <Menu
                        open={Boolean(menuPos && selectedRow)}
                        onClose={handleCloseActionsMenu}
                        anchorReference="anchorPosition"
                        anchorPosition={menuPos ? { top: menuPos.top, left: menuPos.left } : undefined}
                        PaperProps={{
                            sx: {
                                borderRadius: 1,
                                minWidth: 220,
                                boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
                                overflow: "hidden",
                                mt: 1,
                            },
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                handleCloseActionsMenu();
                                handleEditUnavailability(selectedRow)
                            }}
                            sx={{ py: 1.25 }}
                        >
                            <SelectedMenu label="Editar informações" icon={<EditOutlined fontSize="small" />} />
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                                handleCloseActionsMenu();
                                setOpen(true)
                            }}
                            disabled={!isAuthorizedToViewUserAuthorityGroup}
                            sx={{ py: 1.25 }}
                        >
                            <SelectedMenu label="Associar perfis de acesso" icon={<AccountCircleOutlinedIcon fontSize="small" />} />
                        </MenuItem>

                        <Divider />

                        <MenuItem
                            onClick={() => {
                                handleCloseActionsMenu();
                                handleDeleteUsers(selectedRow)
                            }}
                            sx={{ py: 1.25 }}
                        >
                            <SelectedMenu label="Excluir" icon={<DeleteOutlined fontSize="small" />} danger />
                        </MenuItem>
                    </Menu>
                </Box>
            </ACard>
            <SideBar
                open={open}
                onCloseModal={handleOnClosed}
                selectedPermissions={onSetSelectedPermissions}
                initialPermissions={permissions}
                user={selectedUser}
            />
            <ConfirmDialog
                title={'Deletar'}
                description={'Deseja deletar esse Usuário?'}
                open={openDialog}
                handleConfirm={handleDialogConfirm}
                handleClose={handleDialogClose}
            />
        </Box>
    );
}

export default function UsersHomePage() {
    return (
        <QueryClientProvider client={queryClient}>
            <UsersSettingsPage/>
        </QueryClientProvider>
    )
}
